import Moment from 'moment'
import * as Redux from 'redux'
import * as IsActive from '../../../components/is_active'
import * as Sortable from '../../../components/sortable'
import * as Constants from './constants'
import * as Types from './types'
import * as Utils from './utils'

const normalizeTypes = (filterType: Types.FilterType, sourceType: Types.SourceType) =>
  (filters: Types.Filter[]): Types.Filter[] => {
    return Utils.filtered(filters, filterType, sourceType).map((f: Types.Filter) => ({
      ...f,
      created_datetime: Moment(f.created),
    }))
}

const sortableReducerEvent =
  (filterType: Types.FilterType, sourceType: Types.SourceType): Sortable.ReducerEvent<Types.Filter> => {
  return {
    defaultSort: {field: 'tag', dir: 'asc'},
    normalizer: normalizeTypes(filterType, sourceType),
    requestEvent: Constants.FETCH_FILTERS,
    sortEvent: Utils.requestEvent(filterType, sourceType),
  }
}

const sortableReducer = (filterType: Types.FilterType, sourceType: Types.SourceType): any => {
  const sortableEvent = sortableReducerEvent(filterType, sourceType)
  return Redux.combineReducers({
    data: IsActive.chainedReducer(
      Sortable.stateReducer(sortableEvent),
      Utils.updateStatusEvent(filterType, sourceType)),
    view: Sortable.viewReducer(sortableEvent),
  })
}

export const reducer = Redux.combineReducers({
  excluded_groups: sortableReducer(Constants.TYPE_EXCLUDED, Constants.SOURCE_GROUP),
  excluded_tags: sortableReducer(Constants.TYPE_EXCLUDED, Constants.SOURCE_TAG),
  included_groups: sortableReducer(Constants.TYPE_INCLUDED, Constants.SOURCE_GROUP),
  included_tags: sortableReducer(Constants.TYPE_INCLUDED, Constants.SOURCE_TAG),
})



// WEBPACK FOOTER //
// ./src/pages/source-config/filters/reducer.ts